module.exports = "<h2>{{'menu.main.manage.title' | translate}}</h2>\n\n<p>{{body}}</p>\n\n<div class=\"action-footer\">\n  <button class=\"button secondary\" ng-click=\"cancel()\">{{'common.buttons.no' | translate}}</button>\n  <button class=\"button\" ng-click=\"manage()\">{{'common.buttons.si' | translate}}</button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/menu/catalog/catalog.manage.modal.html
 ** module id = 608
 ** module chunks = 0
 **/